/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Parcel_IdsInputs */

const cs_property_registry_parcel_ids = /** @type {(inputs: Property_Registry_Parcel_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID parcel`)
};

const en_property_registry_parcel_ids = /** @type {(inputs: Property_Registry_Parcel_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcel IDs`)
};

/**
* | output |
* | --- |
* | "Parcel IDs" |
*
* @param {Property_Registry_Parcel_IdsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_parcel_ids = /** @type {((inputs?: Property_Registry_Parcel_IdsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Parcel_IdsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_parcel_ids(inputs)
	return cs_property_registry_parcel_ids(inputs)
});